import { render, staticRenderFns } from "./BaseLoginButton.vue?vue&type=template&id=4f371d2c&scoped=true"
import script from "./BaseLoginButton.vue?vue&type=script&lang=js"
export * from "./BaseLoginButton.vue?vue&type=script&lang=js"
import style0 from "./BaseLoginButton.vue?vue&type=style&index=0&id=4f371d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f371d2c",
  null
  
)

export default component.exports